import { render } from "./MainNavigation.vue?vue&type=template&id=861211b4&scoped=true"
import script from "./MainNavigation.vue?vue&type=script&lang=js"
export * from "./MainNavigation.vue?vue&type=script&lang=js"

import "./MainNavigation.vue?vue&type=style&index=0&id=861211b4&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/2026_cdf/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-861211b4"]])

export default __exports__